import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.initializeCableConnection()
  }

  disconnect() {
    if (this.streamSubscription) {
      this.streamSubscription.unsubscribe()
    }
  }

  initializeCableConnection() {
    this.waitForActionCable()
  }

  setupCableConnection() {
    console.log("⚡ Attempting to initialize cable connection");

    let signedStreamName = document.querySelector('meta[name="turbo-cable-stream-source"]')?.getAttribute('content');

    if (!signedStreamName) {
      const streamSourceElement = document.querySelector('turbo-cable-stream-source');
      if (streamSourceElement) {
        signedStreamName = streamSourceElement.getAttribute('signed-stream-name');
      }
    }

    if (!signedStreamName) {
      console.warn("No signed stream name found. Make sure your view includes a meta tag with name='turbo-cable-stream-source'");
      return false;
    }

    if (!window.App || !window.App.cable) {
      console.log("ActionCable not ready yet, will retry...");
      return false;
    }

    console.log("Setting up stream subscription");

    this.streamSubscription = App.cable.subscriptions.create(
      {
        channel: "Turbo::StreamsChannel",
        signed_stream_name: signedStreamName
      },
      {
        connected() {
          console.log("✅ Connected to stream subscription");
        },
        disconnected() {
          console.log("Disconnected from stream subscription");
        },
        received(data) {
          if (typeof data === 'string' && data.includes('turbo-stream')) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;

            const streamElements = tempDiv.querySelectorAll('turbo-stream');
            if (streamElements.length > 0) {
              streamElements.forEach(element => {
                const clone = element.cloneNode(true);
                document.body.appendChild(clone);
              });
            }
          }
        }
      }
    );

    console.log("Stream subscription setup complete");
    return true;
  }

  waitForActionCable() {
    let attempts = 0;
    const maxAttempts = 20;
    const retryInterval = 100;

    const tryInitialize = () => {
      attempts++;
      console.log(`Attempt ${attempts}/${maxAttempts} to initialize cable connection`);

      if (this.setupCableConnection()) {
        console.log("✅ Cable connection initialized successfully");
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(tryInitialize, retryInterval);
      } else {
        console.error("❌ Failed to initialize cable connection after", maxAttempts, "attempts");
      }
    };

    tryInitialize();
  }
}